import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate and useLocation
import './Header.css';
import logo from '../../assets/Martin-red.png';
import HamburgerIcon from '../../assets/Hamburger_icon.svg.png';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = -document.querySelector('.header').offsetHeight;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  const handleNavigation = (sectionId) => {
    if (location.pathname === '/') {
      // If already on the homepage, just scroll to the section
      scrollToSection(sectionId);
    } else {
      // If not on the homepage, navigate to it and pass the section id
      navigate('/', { state: { sectionId } });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className={`header ${menuOpen ? 'open' : ''}`}>
      <Link to="/"> {/* Link to homepage when the logo is clicked */}
        <img src={logo} alt="Logo" className="redLogo" />
      </Link>
      <div className="established">- since 1977 -</div>
      <div className={`navSection ${menuOpen ? 'mobile show' : 'mobile'}`} ref={navRef}>
        <div className="navElements mobile" onClick={() => handleNavigation('AboutUs')}>ABOUT</div>
        <div className="navElements mobile" onClick={() => handleNavigation('Team')}>TEAM</div>
        <div className="navElements mobile" onClick={() => handleNavigation('Clients')}>CLIENTS</div>
        <Link to="/auto" className="navElements mobile autoPageLink">AUTO</Link> 
        <Link to="/careers" className="navElements mobile">JOBS</Link> {/* Link to careers page */}
        <div className="navElements mobile sayHelloButton" onClick={() => handleNavigation('Contact')}>SAY HELLO</div>
      </div>
      <img src={HamburgerIcon} alt="Menu" className="hamburger-menu" onClick={toggleMenu} />
      <nav className="navSection">
        <div className="navElements" onClick={() => handleNavigation('AboutUs')}>ABOUT</div>
        <div className="navElements" onClick={() => handleNavigation('Team')}>TEAM</div>
        <div className="navElements" onClick={() => handleNavigation('Clients')}>CLIENTS</div>
        <Link to="/auto" className="navElements autoPageLink">AUTO</Link> 
        <Link to="/careers" className="navElements">JOBS</Link>
        <div className="navElements sayHelloButton" onClick={() => handleNavigation('Contact')}>SAY HELLO</div>
      </nav>

    </header>
  );
};

export default Header;
